import { createContext, useContext } from 'react';

export const PERFORMANCE_STORAGE_KEY = 'xinghuo-admin-performance-mode-v1';

export const normalizePerformanceMode = (mode) => {
  if (mode === 'safe' || mode === 'full' || mode === 'auto') return mode;
  return 'auto';
};

export const detectLowPerformanceDevice = () => {
  if (typeof window === 'undefined') return false;

  const nav = window.navigator || {};
  const cores = Number(nav.hardwareConcurrency || 0);
  const memory = Number(nav.deviceMemory || 0);
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

  return Boolean(
    reducedMotion ||
    (cores > 0 && cores <= 4) ||
    (memory > 0 && memory <= 4)
  );
};

export const resolvePerformanceMode = (mode) => {
  const normalized = normalizePerformanceMode(mode);
  if (normalized === 'auto') {
    return detectLowPerformanceDevice() ? 'safe' : 'full';
  }
  return normalized;
};

export const getInitialPerformanceMode = () => {
  return 'safe';
};

export const applyPerformanceMode = (mode) => {
  const normalized = normalizePerformanceMode(mode);
  const effectiveMode = resolvePerformanceMode(normalized);

  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-performance-pref', normalized);
    document.documentElement.setAttribute('data-performance', effectiveMode);
    document.body?.setAttribute('data-performance-pref', normalized);
    document.body?.setAttribute('data-performance', effectiveMode);
  }

  return effectiveMode;
};

export const PerformanceModeContext = createContext({
  performanceMode: 'auto',
  effectivePerformanceMode: 'full',
  isPerformanceSafe: false,
  setPerformanceMode: () => {},
  togglePerformanceMode: () => {},
});

export const usePerformanceMode = () => useContext(PerformanceModeContext);
